export const unknownTrimLevelId = 'unknown-trim-level'

export const maxMileage = 300000
